import React from 'react';
import { useGcal } from '..';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Attempts to authenticate user if not already authenticated, then renders child component
 * @param props
 */
export function GcalAuthentication({
  children,
}: {
  children: React.ReactNode;
}) {
  const auth = useGcal();
  const location = useLocation();

  if (!auth.user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }
  return children;
}
